import useGetItineraryId from '@/src/hooks/itinerary/useGetItineraryId'
import useClevertapEvent from '..'

const useClevertapForBookFailed = () => {
    const { triggerEvent } = useClevertapEvent()
    const itineraryId = useGetItineraryId()

    const triggerBookFailedEvent = (name: string, payload: any) => {
        const finalPayload = {
            ...payload,
            itineraryId,
        }

        triggerEvent(name, finalPayload)
    }

    return {
        triggerBookFailedEvent
    }
}   

export default useClevertapForBookFailed
